import React from 'react';
import CountdownTimer from '../countdown-timer/CountdownTimer';
import { makeStyles } from '@material-ui/core/styles';
import { primaryText, white } from '../../utils/CssGlobalVariables';


function CarouselCountdownTimer({ timerContent, onRemoveCDT}) {
    
  const bgColor = timerContent.timerBGColor!=undefined && timerContent.timerBGColor;
  const fontColor = timerContent.timerFontColor !=undefined && timerContent.timerFontColor;

  let inlineStyle = makeStyles({
    root:{
      backgroundColor: `${bgColor!==''?bgColor: white} !important`,
      color: `${fontColor!==''?fontColor: primaryText} !important`
    }
  })
  return (
    <div className="carousel-description-countdowntimer">
       <CountdownTimer className={'responsive-carousel-timer-container ' + inlineStyle().root} onRemoveCDT={onRemoveCDT} date={timerContent.timerDateTime} />
    </div> 
  );
}

export default CarouselCountdownTimer;
